import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { CacheDuration } from '../constants/app.constant';


interface CacheEntry {
  value: string;
  expiry: number;
}
 
@Injectable({ providedIn: 'root' })
export class InternalCacheService {
 
  private memoryCache = new Map<string, CacheEntry>();
  private isBrowser: boolean;
 
  constructor(
    private localStorage: LocalStorageService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.cleanExpiredLocalStorage();
  }

    set(key: string, value: string, expiry?: number): boolean {
        expiry = expiry || CacheDuration.Default;
    
        const ttl =
        expiry >= Number.MAX_VALUE
            ? Number.MAX_VALUE
            : Date.now() + expiry * 1000;
    
        const entry: CacheEntry = { value, expiry: ttl  };
    
        if (this.isBrowser) {
            try {              
                this.localStorage.store(key, entry);
            } catch {                  
                this.memoryCache.set(key, entry);
            }
        } else {
            this.memoryCache.set(key, entry);
        }
    
        return true;
    }

    get(key: string): string | null {
        let entry: CacheEntry | null = null;
    
        if (this.isBrowser) {
        entry = this.localStorage.retrieve(key);
        }
    
        if (!entry) {
            entry = this.memoryCache.get(key) || null;
        }
    
        if (!entry) return null;
    
        if (entry.expiry !== Number.MAX_VALUE && Date.now() > entry.expiry) {
            this.remove(key);
            return null;
        }
        return entry.value;
    }

    remove(key: string): void {        
        this.memoryCache.delete(key);        
        if (this.isBrowser) {
            this.localStorage.clear(key);
        }
    }

    clear(): void {
        this.memoryCache.clear();
        if (this.isBrowser) {
            this.localStorage.clear();
        }
    }

    private cleanExpiredLocalStorage(): void {
        if (!this.isBrowser) return;
        const now = Date.now();
        Object.keys(localStorage).forEach((key) => {
            const entry = this.localStorage.retrieve(key) as CacheEntry | null;
            if (entry && entry.expiry !== Number.MAX_VALUE && entry.expiry < now) {
                this.localStorage.clear(key);
            }
        });
    }

}